export default __webpack_public_path__ + "static/media/J_Janela.877bd36f.svg";